import { Box, styled, Typography } from "@material-ui/core";
import { ChevronLeft } from "@material-ui/icons";
import { Link } from "react-router-dom";
import {
  EPOCUS_BORDER,
  EPOCUS_PRIMARY,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "../../_lib/epocus-palette";
import { epocusTheme } from "../../_lib/epocus-theme-provider";

export const BillingPageRoot = styled(Box)({
  padding: 16,
  display: "flex",
  flexDirection: "column",
  gap: 16,
  maxWidth: 760,
  margin: "0 auto",
  [epocusTheme.breakpoints.up("sm")]: {
    padding: 24,
  },
});

export const BillingCard = styled(Box)({
  backgroundColor: EPOCUS_WHITE,
  borderRadius: 12,
  border: `1px solid ${EPOCUS_BORDER}`,
  overflow: "hidden",
});

export const BillingCardHeader = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 10,
  flexWrap: "wrap",
  padding: "14px 16px",
  borderBottom: `1px solid ${EPOCUS_BORDER}`,
});

export const BillingCardTitle = styled("h3")({
  margin: 0,
  fontSize: rem(15),
  fontWeight: 700,
  color: EPOCUS_TEXT_PRIMARY,
});

export const BillingHint = styled(Typography)({
  fontSize: rem(12.5),
  color: EPOCUS_TEXT_SECONDARY,
});

const CrumbLink = styled(Link)({
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  fontSize: rem(13),
  fontWeight: 600,
  color: EPOCUS_PRIMARY,
  textDecoration: "none",
});

export const BillingCrumb: FC<{ to: string; label: string }> = ({
  to,
  label,
}) => (
  <CrumbLink to={to}>
    <ChevronLeft style={{ fontSize: rem(18) }} />
    {label}
  </CrumbLink>
);

export const BillingPageHeading: FC<{ title: string; subtitle: string }> = ({
  title,
  subtitle,
}) => (
  <Box>
    <Typography
      variant="h5"
      style={{
        fontWeight: 700,
        color: EPOCUS_TEXT_PRIMARY,
        fontSize: rem(24),
        lineHeight: 1.2,
      }}
    >
      {title}
    </Typography>
    <Typography
      style={{ fontSize: rem(13), color: EPOCUS_TEXT_SECONDARY, marginTop: 4 }}
    >
      {subtitle}
    </Typography>
  </Box>
);
